import _ from 'lodash';

export const removeUndefined = (obj: Object) => {
  return _.pickBy(obj, (key) => !_.isUndefined(key));;
};
